export default __webpack_public_path__ + "styles/adminPanel.bd226d46e1b211e03c62f79503d8034f.css";